// extracted by mini-css-extract-plugin
module.exports = {"title":"FooterMenuList_title__QN9R_","link":"FooterMenuList_link__zJJdl","main":"FooterMenuList_main__VKfN9","item":"FooterMenuList_item__QZnlO"};